"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Exports a boolean value reporting whether the given API is supported or not
 */

var isApiSupported = function isApiSupported(api) {
  return typeof window !== 'undefined' ? api in window : false;
};

exports.default = isApiSupported;